// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Colors */
/****BRAND COLORS*****/
/****END BRAND COLORS*****/
/* Color Classes*/
/*#region*/
.blue.background {
  background: rgb(22, 109, 255) !important;
}
.blue.text {
  color: rgb(22, 109, 255) !important;
}

.green.background {
  background: rgb(124, 187, 46) !important;
}
.green.text {
  color: rgb(124, 187, 46) !important;
}

.gold.background {
  background: rgb(255, 189, 28) !important;
}
.gold.text {
  color: rgb(255, 189, 28) !important;
}

.orange.background {
  background: rgb(255, 132, 35) !important;
}
.orange.text {
  color: rgb(255, 132, 35) !important;
}

.red.background {
  background: rgb(255, 0, 0) !important;
}
.red.text {
  color: rgb(255, 0, 0) !important;
}

.pink.background {
  background: rgb(255, 47, 154) !important;
}
.pink.text {
  color: rgb(255, 47, 154) !important;
}

.purple.background {
  background: rgb(177, 0, 234) !important;
}
.purple.text {
  color: rgb(177, 0, 234) !important;
}

.cyan.background {
  background: rgb(48, 205, 155) !important;
}
.cyan.text {
  color: rgb(48, 205, 155) !important;
}

/*#endregion*/
/* Font */
/* Shadows */
/* Borders */
/* Transitions and Animations*/
/* Z Index */
.create_order_page .catalog {
  padding-top: 20px;
  overflow-y: auto;
  height: 100%;
  max-height: 100%;
  max-width: 100%;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 20px;
  grid-template-areas: ". . . . ." ". . . . ." ". . . . .";
  display: grid;
}
.create_order_page .catalog .catalog_item {
  padding: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: rgba(50, 50, 50, 0.1) 2px 3px 10px;
  border-radius: 0px;
  transition: 200ms;
  opacity: 0;
  transform: translateY(40px);
  cursor: pointer;
  animation: slide-in 400ms forwards;
}
.create_order_page .catalog .catalog_item:hover {
  box-shadow: rgba(50, 50, 50, 0.15) 4px 5px 10px;
}
.create_order_page .catalog .catalog_item:hover .button {
  color: rgb(255, 255, 255);
  background: rgb(22, 109, 255);
}
.create_order_page .catalog .catalog_item:hover .button svg {
  transition: all 200ms;
  transform: translateX(5px);
}
.create_order_page .catalog .catalog_item > div {
  margin: 5px 0px;
}
.create_order_page .catalog .catalog_item .title_container {
  flex: 2 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.create_order_page .catalog .catalog_item .money {
  flex: 1 1;
  text-align: center;
  font-weight: 800;
  color: rgb(22, 109, 255);
}
.create_order_page .catalog .catalog_item .button_container {
  flex: 2 1;
}
.create_order_page .order_modal_wrapper {
  width: 90vw;
  max-width: 600px;
  padding: 25px;
}
.create_order_page .order_modal_wrapper > div {
  margin: 10px 0px;
}
.create_order_page .order_modal_wrapper .product_cost {
  display: block;
  margin: 10px 0px;
  color: rgb(124, 187, 46);
  text-align: center;
  font-size: 26px;
}
.create_order_page .order_modal_wrapper .product_title {
  width: 100%;
  max-width: none;
  font-size: 30px;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
}
.create_order_page .order_modal_wrapper .product_description {
  padding: 0px 10px;
  margin: 0px 5px;
  max-height: 220px;
  overflow-y: scroll;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.6);
}
.create_order_page .order_modal_wrapper .product_info {
  display: flex;
  cursor: default;
}
.create_order_page .order_modal_wrapper .product_info > div {
  flex: 1 1;
  background: rgb(22, 109, 255);
  color: rgb(255, 255, 255);
  border-radius: 20px;
  padding: 7px;
  margin: 10px;
  text-align: center;
}
.create_order_page .order_modal_wrapper .product_variant_dropdown_wrapper {
  display: flex;
}
.create_order_page .order_modal_wrapper .product_variant_dropdown_wrapper .product_variant_dropdown {
  padding: 5px;
  margin: 10px;
}
.create_order_page .order_modal_wrapper .product_variant_dropdown_wrapper .product_variant_dropdown label {
  margin-right: 5px;
}
.create_order_page .order_modal_wrapper .product_variant_dropdown_wrapper .product_variant_dropdown select {
  padding: 5px;
  border: none;
  border-bottom: 2px solid rgb(22, 109, 255);
  font-size: 15px;
}
.create_order_page .order_modal_wrapper .product_button_qty_wrapper {
  display: flex;
  align-items: center;
}
.create_order_page .order_modal_wrapper .product_button_qty_wrapper .product_qty {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  margin: 10px;
}
.create_order_page .order_modal_wrapper .product_button_qty_wrapper .product_qty input {
  max-width: 50px;
  padding: 5px;
  border: none;
  font-size: 18px;
}
.create_order_page .order_modal_wrapper .product_button_qty_wrapper .product_button {
  flex: 3 1;
  margin: 0px;
}
.create_order_page .order_modal_wrapper .product_button_qty_wrapper .add_to_cart_total {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.create_order_page .order_modal_wrapper .product_button_qty_wrapper .add_to_cart_total label {
  margin-right: 5px;
}
.create_order_page .order_modal_wrapper .product_button_qty_wrapper .add_to_cart_total span {
  color: rgb(124, 187, 46);
}

@keyframes slide-in {
  0% {
    opacity: 0;
    transform: translateY(40px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.catalog .catalog_item:nth-child(1n) {
  animation-delay: 0.05s;
}

.catalog .catalog_item:nth-child(2n) {
  animation-delay: 0.1s;
}

.catalog .catalog_item:nth-child(3n) {
  animation-delay: 0.15s;
}

.catalog .catalog_item:nth-child(4n) {
  animation-delay: 0.2s;
}

.catalog .catalog_item:nth-child(5n) {
  animation-delay: 0.25s;
}

.catalog .catalog_item:nth-child(6n) {
  animation-delay: 0.3s;
}

.catalog .catalog_item:nth-child(7n) {
  animation-delay: 0.35s;
}

.catalog .catalog_item:nth-child(8n) {
  animation-delay: 0.4s;
}

.catalog .catalog_item:nth-child(9n) {
  animation-delay: 0.45s;
}

.catalog .catalog_item:nth-child(10n) {
  animation-delay: 0.5s;
}

.catalog .catalog_item:nth-child(11n) {
  animation-delay: 0.55s;
}

.catalog .catalog_item:nth-child(12n) {
  animation-delay: 0.6s;
}

.catalog .catalog_item:nth-child(13n) {
  animation-delay: 0.65s;
}

.catalog .catalog_item:nth-child(14n) {
  animation-delay: 0.7s;
}

.catalog .catalog_item:nth-child(15n) {
  animation-delay: 0.75s;
}

.catalog .catalog_item:nth-child(16n) {
  animation-delay: 0.8s;
}

.catalog .catalog_item:nth-child(17n) {
  animation-delay: 0.85s;
}

.catalog .catalog_item:nth-child(18n) {
  animation-delay: 0.9s;
}

.catalog .catalog_item:nth-child(19n) {
  animation-delay: 0.95s;
}

.catalog .catalog_item:nth-child(20n) {
  animation-delay: 1s;
}

.catalog .catalog_item:nth-child(21n) {
  animation-delay: 1.05s;
}

.catalog .catalog_item:nth-child(22n) {
  animation-delay: 1.1s;
}

.catalog .catalog_item:nth-child(23n) {
  animation-delay: 1.15s;
}

.catalog .catalog_item:nth-child(24n) {
  animation-delay: 1.2s;
}

.catalog .catalog_item:nth-child(25n) {
  animation-delay: 1.25s;
}

.catalog .catalog_item:nth-child(26n) {
  animation-delay: 1.3s;
}

.catalog .catalog_item:nth-child(27n) {
  animation-delay: 1.35s;
}

.catalog .catalog_item:nth-child(28n) {
  animation-delay: 1.4s;
}

.catalog .catalog_item:nth-child(29n) {
  animation-delay: 1.45s;
}

.catalog .catalog_item:nth-child(30n) {
  animation-delay: 1.5s;
}

.catalog .catalog_item:nth-child(31n) {
  animation-delay: 1.55s;
}

.catalog .catalog_item:nth-child(32n) {
  animation-delay: 1.6s;
}

.catalog .catalog_item:nth-child(33n) {
  animation-delay: 1.65s;
}

.catalog .catalog_item:nth-child(34n) {
  animation-delay: 1.7s;
}

.catalog .catalog_item:nth-child(35n) {
  animation-delay: 1.75s;
}

.catalog .catalog_item:nth-child(36n) {
  animation-delay: 1.8s;
}

.catalog .catalog_item:nth-child(37n) {
  animation-delay: 1.85s;
}

.catalog .catalog_item:nth-child(38n) {
  animation-delay: 1.9s;
}

.catalog .catalog_item:nth-child(39n) {
  animation-delay: 1.95s;
}

.catalog .catalog_item:nth-child(40n) {
  animation-delay: 2s;
}

.catalog .catalog_item:nth-child(41n) {
  animation-delay: 2.05s;
}

.catalog .catalog_item:nth-child(42n) {
  animation-delay: 2.1s;
}

.catalog .catalog_item:nth-child(43n) {
  animation-delay: 2.15s;
}

.catalog .catalog_item:nth-child(44n) {
  animation-delay: 2.2s;
}

.catalog .catalog_item:nth-child(45n) {
  animation-delay: 2.25s;
}

.catalog .catalog_item:nth-child(46n) {
  animation-delay: 2.3s;
}

.catalog .catalog_item:nth-child(47n) {
  animation-delay: 2.35s;
}

.catalog .catalog_item:nth-child(48n) {
  animation-delay: 2.4s;
}

.catalog .catalog_item:nth-child(49n) {
  animation-delay: 2.45s;
}

.catalog .catalog_item:nth-child(50n) {
  animation-delay: 2.5s;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/components/orders/create-order/_createOrder.scss"],"names":[],"mappings":"AAGA,UAAA;AACA,sBAAA;AASA,0BAAA;AAoBA,iBAAA;AACA,UAAA;AAEI;EACI,wCAAA;AC9BR;ADgCI;EACI,mCAAA;AC9BR;;ADkCI;EACI,wCAAA;AC/BR;ADiCI;EACI,mCAAA;AC/BR;;ADmCI;EACI,wCAAA;AChCR;ADkCI;EACI,mCAAA;AChCR;;ADoCI;EACI,wCAAA;ACjCR;ADmCI;EACI,mCAAA;ACjCR;;ADqCI;EACI,qCAAA;AClCR;ADoCI;EACI,gCAAA;AClCR;;ADsCI;EACI,wCAAA;ACnCR;ADqCI;EACI,mCAAA;ACnCR;;ADuCI;EACI,uCAAA;ACpCR;ADsCI;EACI,kCAAA;ACpCR;;ADwCI;EACI,wCAAA;ACrCR;ADuCI;EACI,mCAAA;ACrCR;;ADwCA,aAAA;AAEA,SAAA;AAOA,YAAA;AAUA,YAAA;AAMA,8BAAA;AAIA,YAAA;AC7HI;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,+BAAA;EACA,SAAA;EACA,wDACI;EAGJ,aAAA;AA8DR;AA7DQ;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8CDyFC;ECxFD,kBDiGI;EChGJ,iBDsGO;ECrGP,UAAA;EACA,2BAAA;EACA,eAAA;EACA,kCAAA;AA+DZ;AA7DY;EACI,+CDiFG;AClBnB;AA7DgB;EACI,yBDZD;ECaC,6BDlBJ;ACiFhB;AA7DoB;EACI,qBAAA;EACA,0BAAA;AA+DxB;AA1DY;EACI,eAAA;AA4DhB;AA1DY;EACI,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA4DhB;AA1DY;EACI,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBDxCA;ACoGhB;AA1DY;EACI,SAAA;AA4DhB;AAxDI;EACI,WAAA;EACA,gBAAA;EACA,aAAA;AA0DR;AAxDQ;EACI,gBAAA;AA0DZ;AAvDQ;EACI,cAAA;EACA,gBAAA;EACA,wBDrEJ;ECsEI,kBAAA;EACA,eAAA;AAyDZ;AAvDQ;EACI,WAAA;EACA,eAAA;EACA,eAAA;EACA,yBD/DW;ECgEX,kBAAA;AAyDZ;AAvDQ;EACI,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBDxEW;ACiIvB;AAvDQ;EACI,aAAA;EACA,eAAA;AAyDZ;AAxDY;EACI,SAAA;EACA,6BDnFA;ECoFA,yBD/EG;ECgFH,mBDqBD;ECpBC,YAAA;EACA,YAAA;EACA,kBAAA;AA0DhB;AAvDQ;EACI,aAAA;AAyDZ;AAxDY;EACI,YAAA;EACA,YAAA;AA0DhB;AAzDgB;EACI,iBAAA;AA2DpB;AAzDgB;EACI,YAAA;EACA,YAAA;EACA,0CAAA;EACA,eAAA;AA2DpB;AAvDQ;EACI,aAAA;EACA,mBAAA;AAyDZ;AAxDY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AA0DhB;AAvDgB;EACI,eAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAyDpB;AAtDY;EACI,SAAA;EACA,WAAA;AAwDhB;AAtDY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACI,kBAAA;AAwDpB;AAvDgB;EACI,iBAAA;AAyDpB;AAvDgB;EACI,wBDpJZ;AC6MR;;AAlDA;EACI;IACI,UAAA;IACA,2BAAA;EAqDN;EAnDE;IACI,UAAA;IACA,wBAAA;EAqDN;AACF;AAjDI;EACI,sBAAA;AAmDR;;AApDI;EACI,qBAAA;AAuDR;;AAxDI;EACI,sBAAA;AA2DR;;AA5DI;EACI,qBAAA;AA+DR;;AAhEI;EACI,sBAAA;AAmER;;AApEI;EACI,qBAAA;AAuER;;AAxEI;EACI,sBAAA;AA2ER;;AA5EI;EACI,qBAAA;AA+ER;;AAhFI;EACI,sBAAA;AAmFR;;AApFI;EACI,qBAAA;AAuFR;;AAxFI;EACI,sBAAA;AA2FR;;AA5FI;EACI,qBAAA;AA+FR;;AAhGI;EACI,sBAAA;AAmGR;;AApGI;EACI,qBAAA;AAuGR;;AAxGI;EACI,sBAAA;AA2GR;;AA5GI;EACI,qBAAA;AA+GR;;AAhHI;EACI,sBAAA;AAmHR;;AApHI;EACI,qBAAA;AAuHR;;AAxHI;EACI,sBAAA;AA2HR;;AA5HI;EACI,mBAAA;AA+HR;;AAhII;EACI,sBAAA;AAmIR;;AApII;EACI,qBAAA;AAuIR;;AAxII;EACI,sBAAA;AA2IR;;AA5II;EACI,qBAAA;AA+IR;;AAhJI;EACI,sBAAA;AAmJR;;AApJI;EACI,qBAAA;AAuJR;;AAxJI;EACI,sBAAA;AA2JR;;AA5JI;EACI,qBAAA;AA+JR;;AAhKI;EACI,sBAAA;AAmKR;;AApKI;EACI,qBAAA;AAuKR;;AAxKI;EACI,sBAAA;AA2KR;;AA5KI;EACI,qBAAA;AA+KR;;AAhLI;EACI,sBAAA;AAmLR;;AApLI;EACI,qBAAA;AAuLR;;AAxLI;EACI,sBAAA;AA2LR;;AA5LI;EACI,qBAAA;AA+LR;;AAhMI;EACI,sBAAA;AAmMR;;AApMI;EACI,qBAAA;AAuMR;;AAxMI;EACI,sBAAA;AA2MR;;AA5MI;EACI,mBAAA;AA+MR;;AAhNI;EACI,sBAAA;AAmNR;;AApNI;EACI,qBAAA;AAuNR;;AAxNI;EACI,sBAAA;AA2NR;;AA5NI;EACI,qBAAA;AA+NR;;AAhOI;EACI,sBAAA;AAmOR;;AApOI;EACI,qBAAA;AAuOR;;AAxOI;EACI,sBAAA;AA2OR;;AA5OI;EACI,qBAAA;AA+OR;;AAhPI;EACI,sBAAA;AAmPR;;AApPI;EACI,qBAAA;AAuPR","sourcesContent":["// @import './variables';\r\n// @import './common';\r\n\r\n/*Colors */\r\n/****BRAND COLORS*****/\r\n$blue: rgb(22,109,255);\r\n$green: rgb(124,187,46);\r\n$gold: rgb(255,189,28);\r\n$orange: rgb(255,132,35);;\r\n$red: rgb(255,0,0);\r\n$pink: rgb(255,47,154);\r\n$purple: rgb(177,0,234);\r\n$cyan: rgb(48,205,155);\r\n/****END BRAND COLORS*****/\r\n$color_gray: rgb(198, 198, 198);\r\n$color_undefined: rgb(198, 198, 198);\r\n$color_primary: rgb(22,109,255);\r\n$color_error: rgb(224, 70, 70);\r\n$color_disabled: rgba(30,30,30,.3);\r\n$text_color_dark: rgba(0,0,0,1);\r\n$text_color_dark_soft: rgba(0,0,0,.6); \r\n$text_color_light: rgba(255,255,255,1);\r\n$text_color_light_soft: rgba(255,255,255,.5);\r\n$border_color_primary: rgba(30,30,30,.2);\r\n$button_border_color_primary: rgba(31, 74, 193, 1);\r\n$placeholder_color: rgba(30,30,30,.2);\r\n$placeholder_color_hover: rgba(30,30,30,.5);\r\n$navigation_button_color_hover: rgba(194, 205, 238, 0.2);\r\n\r\n$background_color_primary: #fff;\r\n$background_color_secondary: rgb(253, 253, 253);\r\n\r\n\r\n/* Color Classes*/\r\n/*#region*/\r\n.blue {\r\n    &.background {\r\n        background: $blue !important;\r\n    }\r\n    &.text {\r\n        color: $blue !important;\r\n    }\r\n}\r\n.green {\r\n    &.background {\r\n        background: $green !important;\r\n    }\r\n    &.text {\r\n        color: $green !important;\r\n    }\r\n}\r\n.gold {\r\n    &.background {\r\n        background: $gold !important;\r\n    }\r\n    &.text {\r\n        color: $gold !important;\r\n    }\r\n}\r\n.orange {\r\n    &.background {\r\n        background: $orange !important; \r\n    }\r\n    &.text {\r\n        color: $orange !important;\r\n    }\r\n}\r\n.red {\r\n    &.background {\r\n        background: $red !important;\r\n    }\r\n    &.text {\r\n        color: $red !important;\r\n    }\r\n}\r\n.pink {\r\n    &.background {\r\n        background: $pink !important;\r\n    }\r\n    &.text {\r\n        color: $pink !important;\r\n    }\r\n}\r\n.purple {\r\n    &.background {\r\n        background: $purple !important;\r\n    }\r\n    &.text {\r\n        color: $purple !important;\r\n    }\r\n}\r\n.cyan {\r\n    &.background {\r\n        background: $cyan !important;\r\n    }\r\n    &.text {\r\n        color: $cyan !important;\r\n    }\r\n}\r\n/*#endregion*/\r\n\r\n/* Font */\r\n$font_size_button: 14px;\r\n$font_size_navigation: 16px;\r\n$font_size_standard: 14px;\r\n$font_size_subtitle: 24px;\r\n$font_size_small: 12px;\r\n\r\n/* Shadows */\r\n$soft_shadow: rgba(0, 0, 0, 0.2) 0px 24px 38px 3px;\r\n$row_shadow: rgba(50,50,50,.1) 2px 3px 10px;\r\n$row_shadow_hover: rgba(50,50,50,.15) 4px 5px 10px;\r\n$side_nav_shadow: rgba(30, 30, 30, 0.1) 5px 0px 15px 3px;\r\n//$form_input_shadow: rgba(0, 0, 0, 0.1) 0px 10px 10px 0px; //original\r\n$form_input_shadow: rgba(30,30, 30, .1) 2px 2px 10px ;\r\n//$form_input_shadow_hover: rgba(0, 0, 0, 0.11) 2px 14px 10px 0px; //original\r\n$form_input_shadow_hover: rgba(30,30, 30, .15) 4px 4px 15px ;\r\n\r\n/* Borders */\r\n$border_radius: 0px;\r\n$border_button_radius: 0px;\r\n$border_active_width: 0px;\r\n$border_round: 20px;\r\n\r\n/* Transitions and Animations*/\r\n$transition_speed: 200ms;\r\n$animation_speed: 400ms; //currently used for fading in modal\r\n\r\n/* Z Index */\r\n$z_loader: 403;\r\n$z_modal_foreground: 402;\r\n$z_modal_background: 401;\r\n$z_sidecart: 97;\r\n$z_sidecart_background: 96;\r\n$z_select_dropdown: 94;\r\n$z_navbar: 95;","@import \"../../../styles/variables\";\r\n\r\n.create_order_page {\r\n    .catalog {\r\n        padding-top: 20px;\r\n        overflow-y: auto;\r\n        height: 100%;\r\n        max-height: 100%;\r\n        max-width: 100%;\r\n        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\r\n        grid-template-rows: 1fr 1fr 1fr;\r\n        gap: 20px;\r\n        grid-template-areas:\r\n            \". . . . .\"\r\n            \". . . . .\"\r\n            \". . . . .\";\r\n        display: grid;\r\n        .catalog_item {\r\n            padding: 10px;\r\n            display: flex;\r\n            flex-direction: column;\r\n            box-shadow: $row_shadow;\r\n            border-radius: $border-radius;\r\n            transition: $transition_speed;\r\n            opacity: 0;\r\n            transform: translateY(40px);\r\n            cursor: pointer;\r\n            animation: slide-in $animation_speed forwards;\r\n\r\n            &:hover {\r\n                box-shadow: $row_shadow_hover;\r\n\r\n                .button {\r\n                    color: $text_color_light;\r\n                    background: $color_primary;\r\n\r\n                    svg {\r\n                        transition: all $transition_speed;\r\n                        transform: translateX(5px);\r\n                    }\r\n                }\r\n            }\r\n\r\n            & > div {\r\n                margin: 5px 0px;\r\n            }\r\n            .title_container {\r\n                flex: 2;\r\n                display: flex;\r\n                justify-content: center;\r\n                align-items: center;\r\n            }\r\n            .money {\r\n                flex: 1;\r\n                text-align: center;\r\n                font-weight: 800;\r\n                color: $color_primary;\r\n            }\r\n            .button_container {\r\n                flex: 2;\r\n            }\r\n        }\r\n    }\r\n    .order_modal_wrapper {\r\n        width: 90vw;\r\n        max-width: 600px;\r\n        padding: 25px;\r\n\r\n        & > div {\r\n            margin: 10px 0px;\r\n        }\r\n\r\n        .product_cost {\r\n            display: block;\r\n            margin: 10px 0px;\r\n            color: $green;\r\n            text-align: center;\r\n            font-size: 26px;\r\n        }\r\n        .product_title {\r\n            width: 100%;\r\n            max-width: none;\r\n            font-size: 30px;\r\n            color: $text_color_dark_soft;\r\n            text-align: center;\r\n        }\r\n        .product_description {\r\n            padding: 0px 10px;\r\n            margin: 0px 5px;\r\n            max-height: 220px;\r\n            overflow-y: scroll;\r\n            line-height: 20px;\r\n            color: $text_color_dark_soft;\r\n        }\r\n        .product_info {\r\n            display: flex;\r\n            cursor: default;\r\n            & > div {\r\n                flex: 1;\r\n                background: $color_primary;\r\n                color: $text_color_light;\r\n                border-radius: $border_round;\r\n                padding: 7px;\r\n                margin: 10px;\r\n                text-align: center;\r\n            }\r\n        }\r\n        .product_variant_dropdown_wrapper {\r\n            display: flex;\r\n            .product_variant_dropdown {\r\n                padding: 5px;\r\n                margin: 10px;\r\n                label {\r\n                    margin-right: 5px;\r\n                }\r\n                select {\r\n                    padding: 5px;\r\n                    border: none;\r\n                    border-bottom: 2px solid $color_primary;\r\n                    font-size: 15px;\r\n                }\r\n            }\r\n        }\r\n        .product_button_qty_wrapper {\r\n            display: flex;\r\n            align-items: center;\r\n            .product_qty {\r\n                display: flex;\r\n                justify-content: center;\r\n                align-items: center;\r\n                padding: 5px;\r\n                margin: 10px;\r\n                label {\r\n                }\r\n                input {\r\n                    max-width: 50px;\r\n                    padding: 5px;\r\n                    border: none;\r\n                    font-size: 18px;\r\n                }\r\n            }\r\n            .product_button {\r\n                flex: 3;\r\n                margin: 0px;\r\n            }\r\n            .add_to_cart_total {\r\n                display: flex;\r\n                justify-content: center;\r\n                align-items: center;\r\n                    margin-right: 10px;\r\n                label{\r\n                    margin-right: 5px;\r\n                }\r\n                span {\r\n                    color: $green;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@keyframes slide-in {\r\n    0% {\r\n        opacity: 0;\r\n        transform: translateY(40px);\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n@for $i from 1 through 50 {\r\n    .catalog .catalog_item:nth-child(#{$i}n) {\r\n        animation-delay: #{$i * 0.05}s;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
